import { render, staticRenderFns } from "./RfqMgn.vue?vue&type=template&id=20555ea4"
import script from "./RfqMgn.vue?vue&type=script&lang=js"
export * from "./RfqMgn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports